module.exports = __webpack_public_path__ + "img/20171224_174740-min.eba39ba6.jpg";